import { render, staticRenderFns } from "./FileOperationsButtons.vue?vue&type=template&id=565536d9&"
import script from "./FileOperationsButtons.vue?vue&type=script&lang=js&"
export * from "./FileOperationsButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports